import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 28px;
  height: 28px;
  color: ${({ color }: any) => color || '#094994'};
`

// TODO Remove the color prop and style with style/classes
const Analytics = ({ color, title = 'Code Tag', ...rest }: IconProps & { color?: string }) => (
  <StyledIcon viewBox="0 0 28 28" title={title} {...rest}>
    <g stroke="currentColor" strokeWidth={2} fill="none" fillRule="evenodd" strokeLinecap="square">
      <path d="M1 1h26v26H1z" />
      <path d="M5.333 17.467l6.067-6.934 6.067 4.334 5.2-4.334" />
    </g>
  </StyledIcon>
)

Analytics.displayName = 'Analytics'
Analytics.needsWork = true
export default Analytics
